<template>
    <div>


        <header class="d-md-flex d-sm-block justify-content-between text-md-left text-center p-3">
            <template v-if="$t('isgeo') == 1">
                <!--<img src="../../assets/img/logo-wh.svg" width="170" class="">-->
                <img src="@/assets/img/ardi_new_logo.svg" width="100" alt="">
            </template>
            <template v-else>
                <!--<img src="../../assets/img/logoEn.png" height="80" class="mt-3">-->
                <img src="@/assets/img/ardiNewlogoEN.svg" width="100" alt="">
            </template>
            <div class="text-right font-weight-bold title important-title mt-2" v-html="$t('importantheadertext')">
                <!--შემუშავებულია <br/>
            საქართველოს დაზღვევის სახელმწიფო ზედამხედველობის <br/>
            სამსახურის უფროსის 2017 წლის 3 აპრილის <br/>
            N18 ბრძანების შესაბამისად-->
            </div>
        </header>
        <div style="background-color: #bd9bc5 ; height:10px;"> </div>
        <main>
            <div class="text-center mt-3 font-weight-bolder"></div>
            <b-row class="m-0">
                <b-col md="8" sm="12" class="p-2 content-header">
                    <div class="col-md-10 col-sm-12 center-text">{{$t('typesservices')}}</div>
                </b-col>

                <b-col md="4" sm="12" class=" content-header text-center pr-0 pl-0">

                    <div class="col-md-12 col-sm-12  border-bottom border-left" v-if="riskdata.policyInfo[0].v1 === 1"> {{$t('vitamin')}} A</div>
                    <div class="col-md-12 col-sm-12  border-bottom border-left" v-if="riskdata.policyInfo[0].v2 === 1"> {{$t('vitamin')}} B</div>
                    <div class="col-md-12 col-sm-12  border-bottom border-left" v-if="riskdata.policyInfo[0].v3 === 1"> {{$t('vitamin')}} C</div>
                    <div class="col-md-12 col-sm-12  border-bottom border-left" v-if="riskdata.policyInfo[0].v4 === 1"> {{$t('vitamin')}} D</div>
                    <div class="col-md-12 col-sm-12  border-bottom border-left" v-if="riskdata.policyInfo[0].v5 === 1"> {{$t('vitamin')}} E</div>
                    <div class="col-md-12 col-sm-12  border-left"> {{$t('insuranceamount')}} {{riskdata.policyInfo[0].insureR_AMOUNT.split('.')[0]}} {{$t('amount')}}</div>
                </b-col>

                <template v-for="item in riskdata.risks">

                    <template v-if="item.waitingPeriod != 0">
                        <template v-if="item.limitAmount == ''">
                            <b-col md="5" sm="12" class="green-border text-size green-dorder-left p-0">
                                <ul class="a" style="padding-left: 30px; margin-bottom: 0px">
                                    <li>
                                        {{item.riskName}}
                                    </li>
                                </ul>
                            </b-col>
                        </template>
                        <template v-else>
                            <b-col md="5" sm="12" class="green-border text-size green-dorder-left">{{item.riskName}}</b-col>
                        </template>

                        <b-col md="3" sm="12" class="description value-border">
                            <div class="text-center vertical-center">
                                <div>{{$t('waitingperiod')}} {{item.waitingPeriod}} {{$t('month')}}</div>
                            </div>
                        </b-col>

                        <b-col md="2" sm="12" class="description value-border risk-md">
                            <div class="text-center p-1 main-div">
                                <div class="child-div">{{item.linitPercent}}</div>
                            </div>
                        </b-col>
                        <b-col md="2" sm="12" class="description value-border risk-md">
                            <div class="text-center p-1 main-div">
                                <div class="child-div" v-if="item.limitAmount == ''">-</div>
                                <div class="child-div" v-else>{{item.limitAmount}}</div>
                            </div>
                        </b-col>

                        <template v-if="!item.linitPercent">
                            <b-col cols="12" class="description value-border risk-sm">
                                <div class="text-center p-1main-div">
                                    <div class="child-div">{{item.limitAmount}}</div>
                                </div>
                            </b-col>
                        </template>
                        <template v-else-if="!item.limitAmount">
                            <b-col cols="12" class="description value-border  risk-sm">
                                <div class="text-center p-1 main-div">
                                    <div class="child-div">{{item.linitPercent}}</div>
                                </div>
                            </b-col>
                        </template>
                        <template v-else>
                            <b-col cols="6" class="description value-border risk-sm">
                                <div class="text-center p-1 main-div">
                                    <div class="child-div">{{item.linitPercent}}</div>
                                </div>
                            </b-col>
                            <b-col cols="6" class="description value-border  risk-sm">
                                <div class="text-center p-1 main-div">
                                    <div class="child-div">{{item.limitAmount}}</div>
                                </div>
                            </b-col>
                        </template>
                    </template>

                    <template v-else>
                        <template v-if="item.limitAmount == ''">
                            <b-col md="8" sm="12" class="green-border text-size green-dorder-left p-0">
                                <ul class="a" style="padding-left: 30px; margin-bottom: 0px">
                                    <li>
                                        {{item.riskName}}
                                    </li>
                                </ul>
                            </b-col>
                        </template>
                        <template v-else>
                            <b-col md="8" sm="12" class="green-border text-size green-dorder-left">{{item.riskName}}</b-col>
                        </template>


                        <b-col md="2" sm="12" class="description value-border risk-md">
                            <div class="text-center p-1 main-div">
                                <div class="child-div" v-if="item.linitPercent == ''">-</div>
                                <div class="child-div" v-else>{{item.linitPercent}}</div>
                            </div>
                        </b-col>
                        <b-col md="2" sm="12" class="description value-border risk-md">
                            <div class="text-center p-1 main-div">
                                <div class="child-div" v-if="item.limitAmount == ''">-</div>
                                <div class="child-div" v-else>{{item.limitAmount}}</div>
                            </div>
                        </b-col>


                        <template v-if="!item.linitPercent">
                            <b-col cols="12" class="description value-border risk-sm">
                                <div class="text-center p-1 main-div">
                                    <div class="child-div">{{item.limitAmount}}</div>
                                </div>
                            </b-col>
                        </template>
                        <template v-else-if="!item.limitAmount">
                            <b-col cols="12" class="description value-border  risk-sm">
                                <div class="text-center p-1 main-div">
                                    <div class="child-div">{{item.linitPercent}}</div>
                                </div>
                            </b-col>
                        </template>
                        <template v-else>
                            <b-col cols="6" class="description value-border risk-sm">
                                <div class="text-center p-1 main-div">
                                    <div class="child-div">{{item.linitPercent}}</div>
                                </div>
                            </b-col>
                            <b-col cols="6" class="description value-border  risk-sm">
                                <div class="text-center p-1 main-div">
                                    <div class="child-div">{{item.limitAmount}}</div>
                                </div>
                            </b-col>
                        </template>


                    </template>

                </template>

                <b-col md="12" sm="12" class="description dorder-bottom-inside d-flex p-0 dorder-left-right-bottom" v-if="riskdata.policyInfo[0].checkBox2 == 1">
                    <div class="col-md-8 col-sm-12  ">{{$t('premiummonth')}}<br /> {{$t('doctorscheme')}}</div>
                    <template v-if="riskdata.policyInfo[0].payAmaunt2 != null">
                        <div class="text-size-1 col-md-4 d-flex justify-content-center"> {{ riskdata.policyInfo[0].insurancePremiums }} {{$t('currency')}}</div>
                    </template>
                    <template v-else>
                        <div class="text-size-1 col-md-4 d-flex justify-content-center"> {{ riskdata.policyInfo[0].insurancePremiums }} {{$t('currency')}}</div>
                    </template>

                </b-col>

                <b-col md="12" sm="12" class="description  d-flex p-0 dorder-left-right-bottom" v-if="riskdata.policyInfo[0].checkBox2 == 0">
                    <div class="col-md-8 col-sm-12  ">{{$t('premiummonth')}}<br />{{$t('freechoice')}}</div>
                    <template v-if="riskdata.policyInfo[0].payAmaunt2 != null">
                        <div class="text-size-1 col-md-4 d-flex justify-content-center"> {{ riskdata.policyInfo[0].insurancePremiums }} {{$t('currency')}}</div>
                    </template>
                    <template v-else>
                        <div class="text-size-1 col-md-4 d-flex justify-content-center"> {{ riskdata.policyInfo[0].insurancePremiums }} {{$t('currency')}}</div>
                    </template>
                </b-col>

            </b-row>
        </main>

    </div>
</template>

<script>
export default {
  name: "Risk",
  props: ['polid','riskdata'],
    data() {
        return {
            data: null,
            cont: this.$route.params.cont,
            cust: this.$route.params.cust,
        }
    },
       
    mounted() {
    }
}
</script>

<style scoped>

header {
  background: #d9d8d6 !important;
  color: #fafafa;
  /*box-shadow: 0 10px 0 #bd9bc5;*/
}
.title {
  font-size: 18px;
}
ul.a {
    list-style-position: outside;
}

.description-box-c {
  background: #e6e0ea !important;
  color: black !important;
}

.green-text {
  color: #00A886;
}
.text-size{
  font-size: 14px;
}
.green-box {
  background: #007a60 !important;
  color: #fafafa;
}
.content-header {
  background-color: #D0AAD9;
  color: #fff;
  font-size: 14px;
}
.description {
  background-color: #007961;
  color: #fff;
  font-size: 14px;
}


.gray-box{
  background-color: #dedede;
}
.green-dorder-right{
  border-right: 1px solid #00A788;
}
.green-dorder-left{
  border-left: 1px solid #00A788;
}

.dorder-left-right-bottom{
  border-left: 1px solid #00A788;
  border-right: 1px solid #00A788;
  border-bottom: 1px solid #00A788;
}

.dorder-bottom-inside{
  border-bottom: 1px solid #00A788;
}
.dorder-right-inside{
  border-right: 1px solid #00A788;
}


.dorder-rgh-bot-inside{
  border-bottom: 1px solid #00A788;
  border-right: 1px solid #00A788;
}
.green-border {
  border-collapse: collapse;
  border-bottom: 1px solid #00A788;
  border-right: 1px solid #00A788;
}
.value-border{
  border-bottom: 1px solid #00A788;
  border-right: 1px solid #00A788;
}
.text-size-1{
  font-size: 25px;
  font-weight: bold;
}

.risk-sm{
   display: none !important;
}
.risk-md{
   display: block !important;
}
    .main-div {
        height: 100%; 
        width: 100%; 
        display: table; 
    }
    .child-div {
        display: table-cell; 
        vertical-align: middle; 
        text-align: center;
    }

@media (max-width: 500px) 
{
    .text-size-1 {
        height: 87px;
        line-height: 84px;
    }
    .important-title {
        font-size: 16px;
        text-align: center !important;
    }
    .center-text {
        text-align: center !important;
    }
    .risk-sm {
        display: block !important;
    }
    .risk-md {
        display: none !important;
    }
   
   
}
</style>